<!-- @format -->

<template>
	<div class="authorized-person-form-fields">
		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					:condensed="condensed"
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
				>
					{{ $t('§eq_operator.auth_person_first_name') }}
					{{ isFieldRequired('first_name') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreStringInput
					ref="firstNameInput"
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					placeholder="§ui.placeholder_auth_person_first_name"
					name="first_name"
					:condensed="condensed"
					:disabled="isFieldDisabled('first_name')"
					:validator="validator ? validator.first_name : null"
					:modelValue="modelValue.first_name"
					@update:modelValue="updateField('first_name', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					:condensed="condensed"
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
				>
					{{ $t('§eq_operator.auth_person_last_name') }}
					{{ isFieldRequired('last_name') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreStringInput
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					placeholder="§ui.placeholder_auth_person_last_name"
					name="last_name"
					:condensed="condensed"
					:disabled="isFieldDisabled('last_name')"
					:validator="validator ? validator.last_name : null"
					:modelValue="modelValue.last_name"
					@update:modelValue="updateField('last_name', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
					:condensed="condensed"
				>
					<span>
						{{ $t('§eq_operator.auth_person_date_of_birth') }}
						{{ isFieldRequired('date_of_birth') }}
					</span>
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreDateInput
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					name="date_of_birth"
					:condensed="condensed"
					:disabled="isFieldDisabled('date_of_birth')"
					:validator="validator ? validator.date_of_birth : null"
					:modelValue="modelValue.date_of_birth"
					@update:modelValue="updateField('date_of_birth', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
					:condensed="condensed"
				>
					{{ $t('§eq_operator.auth_person_country') }}
					{{ isFieldRequired('country_id') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreDropdown
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					name="person_country"
					:placeholder="$t('§ui.placeholder_auth_person_select_country')"
					:condensed="condensed"
					:disabled="isFieldDisabled('country_id')"
					:options="optionsStore.countrySignatoryResidencyOptions"
					:validator="validator ? validator.country_id : null"
					:modelValue="modelValue.country_id"
					@update:modelValue="updateField('country_id', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
					:condensed="condensed"
				>
					{{ $t('§eq_operator.auth_person_street') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreStringInput
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					placeholder="§ui.placeholder_auth_person_street"
					name="street"
					:condensed="condensed"
					:disabled="isFieldDisabled('street')"
					:modelValue="modelValue.street"
					@update:modelValue="updateField('street', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
					:condensed="condensed"
				>
					{{ $t('§eq_operator.auth_person_postal_code_city') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<div class="flex-grow-1 flex-shrink-1 flex-basis-60 flex">
					<CoreStringInput
						class="flex-basis-40 authorized-person-form-fields__postal-code-input"
						placeholder="§ui.placeholder_auth_person_postal_code"
						name="postal_code"
						:condensed="condensed"
						:disabled="isFieldDisabled('postal_code')"
						:modelValue="modelValue.postal_code"
						@update:modelValue="updateField('postal_code', $event)"
					/>
					<CoreStringInput
						class="flex-basis-60"
						placeholder="§ui.placeholder_auth_person_city"
						name="city"
						:condensed="condensed"
						:disabled="isFieldDisabled('city')"
						:modelValue="modelValue.city"
						@update:modelValue="updateField('city', $event)"
					/>
				</div>
			</template>
		</CoreTwoColumnsRow>

		<CoreTwoColumnsRow class="mb-3">
			<template #left>
				<CoreBorderWrapper
					class="flex-grow-1 flex-shrink-1 flex-basis-40"
					:condensed="condensed"
				>
					{{ $t('§eq_operator.auth_person_address_country') }}
				</CoreBorderWrapper>
			</template>
			<template #right>
				<CoreDropdown
					class="flex-grow-1 flex-shrink-1 flex-basis-60"
					name="address_country"
					:placeholder="$t('§ui.placeholder_auth_person_select_address_country')"
					:condensed="condensed"
					:disabled="isFieldDisabled('address_country_id')"
					:options="optionsStore.countrySignatoryResidencyOptions"
					:validator="validator ? validator.address_country_id : null"
					:modelValue="modelValue.address_country_id"
					@update:modelValue="updateField('address_country_id', $event)"
				/>
			</template>
		</CoreTwoColumnsRow>
	</div>
</template>

<script>
import { useOptionsStore } from '@/stores/options'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreDateInput from '@/components/core/CoreDateInput.vue'

export default {
	name: 'AuthorizedPersonFormFields',

	components: {
		CoreBorderWrapper,
		CoreTwoColumnsRow,
		CoreStringInput,
		CoreDropdown,
		CoreDateInput,
	},

	props: {
		modelValue: {
			type: Object,
			required: true,
		},
		validator: {
			type: Object,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disabledFields: {
			type: Array,
			default: () => [],
		},
		condensed: {
			type: Boolean,
			default: true,
		},
	},

	emits: ['update:modelValue'],

	computed: {
		v$() {
			return this.validator || {}
		},
	},

	created() {
		this.optionsStore = useOptionsStore()
	},

	methods: {
		isFieldDisabled(field) {
			return this.disabled || this.disabledFields.includes(field)
		},

		updateField(field, value) {
			this.$emit('update:modelValue', {
				...this.modelValue,
				[field]: value,
			})
		},

		focusFirstName() {
			if (
				this.$refs.firstNameInput &&
				typeof this.$refs.firstNameInput.focus === 'function'
			) {
				this.$refs.firstNameInput.focus()
			}
		},
	},
}
</script>

<style scoped>
.authorized-person-form-fields__postal-code-input {
	width: 6.4rem;
	margin-right: 16px;
}
</style>
